import userService from '../services/user.service';
import { CHART_SUMMARY_FAILURE, CHART_SUMMARY_PENDING, CHART_SUMMARY_SUCCESS } from './types';

export const getChartSummary = () => async (dispatch) => {
     dispatch({
      type: CHART_SUMMARY_PENDING,
      payload: { chartSummary: "isLoading" },
    });

    try {
        const response = await userService.fetchChartSummary();
        if (response.data.status) {
             dispatch({
                type: CHART_SUMMARY_SUCCESS,
                payload: response.data.result?.[0] || { byEmployees: [], byProducts: [], byPracticeLocations: [] },
            });
        } else {
            dispatch({
                type: CHART_SUMMARY_FAILURE,
                payload: "Failed to fetch chart summary.",
            });
        }
    } catch (error) {
        dispatch({
            type: CHART_SUMMARY_FAILURE,
            payload: error.message || "Something went wrong",
        });
    }
};
